import { useContext } from "react";
import { langContext } from "../../api/Lang";

const el = {
    removeSchoolTitle: "Αφαίρεση σχολείου",
    removeSchoolMsg: 'Είσαι σίγουρος/η ότι θέλεις να αφαιρέσεις το σχολείο "{0}";',
    networkErrorMsg:
        "Δεν ήταν δυνατή η αφαίρεση του σχολείου λόγω σφάλματος δικτύου. Παρακαλώ δοκίμασε ξανά.",
    readdedErrorMsg:
        "Το σχολείο δεν μπόρεσε να αφαιρεθεί επειδή είναι ανοιχτό σε άλλο παράθυρο του browser. Παρακαλώ κλείσε όλα τα παράθυρα με αυτό το σχολείο και δοκίμασε ξανά.",
    navMainLabel: "Κύριο μενού",
    navOrder: "Παραγγελία",
    navPackages: "Πακέτα Σίτισης",
    navTest: "Τεστ",
    unknownSchool: "Άγνωστο σχολείο",
    removeSchoolTooltip: "Αφαίρεση σχολείου",
    demoSchoolFallback: "Σχολείο Demo",
    menuOpen: "Μενού",
    menuOpenWithUpdates: "Μενού, έχεις νέα στοιχεία",
    openingHoursTitle: "ΩΡΕΣ ΛΕΙΤΟΥΡΓΙΑΣ (εστιατόριο σχολείου)",
    mondayFriday: "Δευτέρα - Παρασκευή",
    footerEmailLabel: "Email:",
    footerTelLabel: "Τηλέφωνο:",
    platformSupportFooterLink: "Υποστήριξη πλατφόρμας",
    termsOfUse: "Όροι Χρήσης",
    footerCopyright: (year: number, versionDisplay: string) =>
        `© ${year} Lunchbox. Όλα τα δικαιώματα διατηρούνται. ${versionDisplay}`,
};

const en: typeof el = {
    removeSchoolTitle: "Remove School",
    removeSchoolMsg: 'Are you sure you want to remove the school "{0}"?',
    networkErrorMsg: "Unable to remove the school due to a network error. Please try again.",
    readdedErrorMsg:
        "The school could not be removed because it is open in another browser window. Please close all windows with this school and try again.",
    navMainLabel: "Main menu",
    navOrder: "Order",
    navPackages: "Meal Packages",
    navTest: "Test",
    unknownSchool: "Unknown School",
    removeSchoolTooltip: "Remove school",
    demoSchoolFallback: "Demo School",
    menuOpen: "Menu",
    menuOpenWithUpdates: "Menu, you have new items",
    openingHoursTitle: "OPENING HOURS (school restaurant)",
    mondayFriday: "Monday - Friday",
    footerEmailLabel: "Email:",
    footerTelLabel: "Tel:",
    platformSupportFooterLink: "Platform support",
    termsOfUse: "Terms of Use",
    footerCopyright: (year: number, versionDisplay: string) =>
        `Copyright © ${year} Lunchbox. All Rights Reserved. ${versionDisplay}`,
};

const appLayoutLangs = { el, en };

export function useAppLayoutStrings() {
    const [lang] = useContext(langContext);
    return appLayoutLangs[lang];
}
